// Table of contents:
// 1 header
// 2 orderInformation
// 3 invoiceData
// 4 allowanceCharges
// 5 invoiceItems
// 6 summary
// 7 termsOfPayment
// 8 attachments
//
// allowance charges dialogs
// 9 rejectAllowanceCharges
// 10 acceptAllowanceCharges
// 11 addAllowanceCharge
// 12 infoAllowanceCharge
// 13 editAllowanceCharge
//
// invoice item dialogs
// 14 acceptInvoiceItems
// 15 infoInvoiceItem
// 16 editInvoiceItem
// 17 rejectInvoiceItemAllowanceCharges
// 18 acceptInvoiceItemAllowanceCharges
// 19 addInvoiceItemAllowanceCharge
// 20 infoInvoiceItemAllowanceCharge
// 21 editInvoiceItemAllowanceCharge
//
// terms of payment dialogs
// 22 deleteTermOfPayment
// 23 addTermOfPayment
// 24 editTermOfPayment
//
// invoice dialogs
// 25 rejectInvoice
// 26 acceptInvoice
//
// Attachment dialogs
// 27 uploadAttachment
import { Invoice } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createInvoice = (): Invoice => {
  return {
    // 1 header
    header: {
      enabled: true,
      title: getTranslationsForConfig('invoice.header.title'), // t('invoice.header.title')
      // buyer
      buyerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'invoice.header.buyerInformation.title',
        ), // t('invoice.header.buyerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.externalId',
          ), // t('invoice.header.buyerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.company',
          ), // t('invoice.header.buyerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.department',
          ), // t('invoice.header.buyerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.name',
          ), // t('invoice.header.buyerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.phone',
          ), // t('invoice.header.buyerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.email',
          ), // t('invoice.header.buyerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.address',
          ), // t('invoice.header.buyerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.countryCode',
          ), // t('invoice.header.buyerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.buyerInformation.labels.vatNumber',
          ), // t('invoice.header.buyerInformation.labels.vatNumber')
        },
      },
      // seller
      sellerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'invoice.header.sellerInformation.title',
        ), // t('invoice.header.sellerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.externalId',
          ), // t('invoice.header.sellerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.company',
          ), // t('invoice.header.sellerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.department',
          ), // t('invoice.header.sellerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.name',
          ), // t('invoice.header.sellerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.phone',
          ), // t('invoice.header.sellerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.email',
          ), // t('invoice.header.sellerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.address',
          ), // t('invoice.header.sellerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.countryCode',
          ), // t('invoice.header.sellerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.sellerInformation.labels.vatNumber',
          ), // t('invoice.header.sellerInformation.labels.vatNumber')
        },
      },
      // billing
      billingInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'invoice.header.billingInformation.title',
        ), // t('invoice.header.billingInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.externalId',
          ), // t('invoice.header.billingInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.company',
          ), // t('invoice.header.billingInformation.labels.company')
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.department',
          ), // t('invoice.header.billingInformation.labels.department')
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.name',
          ), // t('invoice.header.billingInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.phone',
          ), // t('invoice.header.billingInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.email',
          ), // t('invoice.header.billingInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.address',
          ), // t('invoice.header.billingInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.countryCode',
          ), // t('invoice.header.billingInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.billingInformation.labels.vatNumber',
          ), // t('invoice.header.billingInformation.labels.vatNumber')
        },
      },
      // shipping
      shippingInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'invoice.header.shippingInformation.title',
        ), // t('invoice.header.shippingInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.externalId',
          ), // t('invoice.header.shippingInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.company',
          ), // t('invoice.header.shippingInformation.labels.company')
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.department',
          ), // t('invoice.header.shippingInformation.labels.department')
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.name',
          ), // t('invoice.header.shippingInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.phone',
          ), // t('invoice.header.shippingInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.email',
          ), // t('invoice.header.shippingInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.address',
          ), // t('invoice.header.shippingInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.countryCode',
          ), // t('invoice.header.shippingInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: false,
          label: getTranslationsForConfig(
            'invoice.header.shippingInformation.labels.vatNumber',
          ), // t('invoice.header.shippingInformation.labels.vatNumber')
        },
      },
    },
    // 2 orderInformation
    orderInformation: {
      enabled: true,
      title: getTranslationsForConfig('invoice.orderInformation.title'), // t('invoice.orderInformation.title')
      orderId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.orderInformation.form.orderId.label',
        ), // t('invoice.orderInformation.form.orderId.label')
      },
      orderDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.orderInformation.form.orderDate.label',
        ), // t('invoice.orderInformation.form.orderDate.label')
      },
      orderDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.orderInformation.form.orderDeliveryDate.label',
        ), // t('invoice.orderInformation.form.orderDeliveryDate.label')
      },
      termsOfDelivery: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.orderInformation.form.termsOfDelivery.label',
        ), // t('invoice.orderInformation.form.termsOfDelivery.label')
      },
      orderCurrency: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.orderInformation.form.orderCurrency.label',
        ), // t('invoice.orderInformation.form.orderCurrency.label')
      },
      confirmationTotalNetItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.orderInformation.form.confirmationTotalNetItemAmount.label',
        ), // t('invoice.orderInformation.form.confirmationTotalNetItemAmount.label')
      },
      orderNotes: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.orderInformation.form.orderNotes.label',
        ), // t('invoice.orderInformation.form.orderNotes.label')
      },
    },
    // 3 invoiceData
    invoiceData: {
      enabled: true,
      title: getTranslationsForConfig('invoice.invoiceData.title'), // t('invoice.invoiceData.title')
      // Rechnungsnummer
      invoiceNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.invoiceNumber.label',
        ), // t('invoice.invoiceData.form.invoiceNumber.label')
        placeholder: getTranslationsForConfig(
          'invoice.invoiceData.form.invoiceNumber.placeholder',
        ), // t('invoice.invoiceData.form.invoiceNumber.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^.{1,16}$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceData.form.invoiceNumber.regexErrorMessage',
          ), // t('invoice.invoiceData.form.invoiceNumber.regexErrorMessage')
        },
      },
      // Rechnugnsart
      deliveryType: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.deliveryType.label',
        ), // t('invoice.invoiceData.form.deliveryType.label')
      },
      // Status
      confirmationCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.confirmationCode.label',
        ), // t('invoice.invoiceData.form.confirmationCode.label')
      },
      // Auftragsbestätigungsnummer
      confirmationId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.confirmationId.label',
        ), // t('invoice.invoiceData.form.confirmationId.label')
      },
      // Auftragsbestätigungsdatum
      confirmationDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.confirmationDate.label',
        ), // t('invoice.invoiceData.form.confirmationDate.label')
      },
      // Lieferscheinnummer
      deliveryNoteNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.deliveryNoteNumber.label',
        ), // t('invoice.invoiceData.form.deliveryNoteNumber.label')
      },
      // Lieferscheindatum
      deliveryNoteDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.deliveryNoteDate.label',
        ), // t('invoice.invoiceData.form.deliveryNoteDate.label')
      },
      // Abteilung
      department: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceData.form.department.label',
        ), // t('invoice.invoiceData.form.department.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Ansprechpartner
      name: {
        enabled: true,
        label: getTranslationsForConfig('invoice.invoiceData.form.name.label'), // t('invoice.invoiceData.form.name.label')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Telefon
      phone: {
        enabled: true,
        label: getTranslationsForConfig('invoice.invoiceData.form.phone.label'), // t('invoice.invoiceData.form.phone.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^[0-9+() -]*$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceData.form.phone.regexErrorMessage',
          ), // t('invoice.invoiceData.form.phone.regexErrorMessage')
        },
      },
      // E-Mail
      email: {
        enabled: true,
        label: getTranslationsForConfig('invoice.invoiceData.form.email.label'), // t('invoice.invoiceData.form.email.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceData.form.email.regexErrorMessage',
          ), // t('invoice.invoiceData.form.email.regexErrorMessage')
        },
      },
      // Hinweistext Lieferant
      notes: {
        enabled: true,
        label: getTranslationsForConfig('invoice.invoiceData.form.notes.label'), // t('invoice.invoiceData.form.notes.label')
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^.{1,25}$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceData.form.notes.regexErrorMessage',
          ), // t('invoice.invoiceData.form.notes.regexErrorMessage')
        },
      },
    },
    // 4 allowanceCharges
    allowanceCharges: {
      enabled: false,
      title: getTranslationsForConfig('invoice.allowanceCharges.title'), // t('invoice.allowanceCharges.title'),
      table: {
        enabled: true,
        title: getTranslationsForConfig('invoice.allowanceCharges.table.title'), // t('invoice.allowanceCharges.table.title'),
        columns: [
          {
            dataType: 'alcType',
            field: 'ConfirmationAlcType',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.allowanceCharges.table.columns.confirmationAlcType.header',
            ), // t('invoice.allowanceCharges.table.columns.confirmationAlcType.header')
            sortable: true,
          },
          {
            dataType: 'string',
            field: 'ConfirmationDescription',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'invoice.allowanceCharges.table.columns.confirmationDescription.filterPlaceholder',
            ), // t('invoice.allowanceCharges.table.columns.confirmationDescription.filterPlaceholder')
            header: getTranslationsForConfig(
              'invoice.allowanceCharges.table.columns.confirmationDescription.header',
            ), // t('invoice.allowanceCharges.table.columns.confirmationDescription.header')
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'percent',
            field: 'ConfirmationPercentage',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.allowanceCharges.table.columns.confirmationPercentage.header',
            ), // t('invoice.allowanceCharges.table.columns.confirmationPercentage.header')
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationAmount',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.allowanceCharges.table.columns.confirmationAmount.header',
            ), // t('invoice.allowanceCharges.table.columns.confirmationAmount.header')
            sortable: true,
          },
          {
            dataType: 'status',
            field: 'Status',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.allowanceCharges.table.columns.status.header',
            ), // t('invoice.allowanceCharges.table.columns.status.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'invoice.allowanceCharges.table.emptyMessageDetails',
        ), // t('invoice.allowanceCharges.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'invoice.allowanceCharges.table.emptyMessageTitle',
        ), // t('invoice.allowanceCharges.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 5 invoiceItems
    invoiceItems: {
      enabled: true,
      title: getTranslationsForConfig('invoice.invoiceItems.title'), // t('invoice.invoiceItems.title'),
      table: {
        enabled: true,
        columns: [
          {
            dataType: 'string',
            field: 'OrderPosition',
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.orderPosition.header',
            ), // t('invoice.invoiceItems.table.columns.orderPosition.header'),
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationSellerProductId.filterPlaceholder',
            ), // t('invoice.invoiceItems.table.columns.confirmationSellerProductId.filterPlaceholder'),
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationSellerProductId.header',
            ), // t('invoice.invoiceItems.table.columns.confirmationSellerProductId.header'),
            sortable: true,
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductDescription',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationSellerProductDescription.filterPlaceholder',
            ), // t('invoice.invoiceItems.table.columns.confirmationSellerProductDescription.filterPlaceholder'),
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationSellerProductDescription.header',
            ), // t('invoice.invoiceItems.table.columns.confirmationSellerProductDescription.header'),
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationPrice',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationPrice.header',
            ), // t('invoice.invoiceItems.table.columns.confirmationPrice.header'),
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationQuantity',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationQuantity.filterPlaceholder',
            ), // t('invoice.invoiceItems.table.columns.confirmationQuantity.filterPlaceholder'),
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationQuantity.header',
            ), // t('invoice.invoiceItems.table.columns.confirmationQuantity.header'),
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationLineItemAmount',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationLineItemAmount.header',
            ), // t('invoice.invoiceItems.table.columns.confirmationLineItemAmount.header'),
            sortable: true,
          },
          {
            align: 'right',
            dataType: 'date',
            field: 'ConfirmationDeliveryDate',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationDeliveryDate.header',
            ), // t('invoice.invoiceItems.table.columns.confirmationDeliveryDate.header'),
            sortable: true,
          },
          {
            align: 'center',
            dataType: 'boolean',
            field: 'HasAllowanceChargeSum',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.hasAllowanceChargeSum.header',
            ), // t('invoice.invoiceItems.table.columns.hasAllowanceChargeSum.header'),
            sortable: true,
          },
          {
            dataType: 'status',
            field: 'ConfirmationCode',
            filter: true,
            header: getTranslationsForConfig(
              'invoice.invoiceItems.table.columns.confirmationCode.header',
            ), // t('invoice.invoiceItems.table.columns.confirmationCode.header'),
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'invoice.invoiceItems.table.emptyMessageDetails',
        ), // t('invoice.invoiceItems.table.emptyMessageDetails'),
        emptyMessageTitle: getTranslationsForConfig(
          'invoice.invoiceItems.table.emptyMessageTitle',
        ), // t('invoice.invoiceItems.table.emptyMessageTitle'),
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 6 summary
    summary: {
      enabled: true,
      title: getTranslationsForConfig('invoice.summary.title'), // t('invoice.summary.title'),
      // Summe Positionsnettowerte
      confirmationTotalNetItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.summary.form.confirmationTotalNetItemAmount.label',
        ), // t('invoice.summary.form.confirmationTotalNetItemAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Gesamtbetrag Zu-/Abschlag (Kopf)
      confirmationSurcharge: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.summary.form.confirmationSurcharge.label',
        ), // t('invoice.summary.form.confirmationSurcharge.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Nettorechnungsbetrag
      confirmationNetAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.summary.form.confirmationNetAmount.label',
        ), // t('invoice.summary.form.confirmationNetAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Steuersatz
      confirmationTaxRate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.summary.form.confirmationTaxRate.label',
        ), // t('invoice.summary.form.confirmationTaxRate.label'),
        readonly: true,
        validation: {
          isRequired: false,
        },
      },
      // Steuerbetrag
      confirmationTaxValue: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.summary.form.confirmationTaxValue.label',
        ), // t('invoice.summary.form.confirmationTaxValue.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Gesamtbetrag
      confirmationInvoiceAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.summary.form.confirmationInvoiceAmount.label',
        ), // t('invoice.summary.form.confirmationInvoiceAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 7 termsOfPayment
    termsOfPayment: {
      enabled: true,
      title: getTranslationsForConfig('invoice.termsOfPayments.title'), // t('invoice.termsOfPayments.title'),
      table: {
        enabled: true,
        columns: [
          {
            align: 'right',
            dataType: 'number',
            field: 'Days',
            header: getTranslationsForConfig(
              'invoice.termsOfPayments.table.columns.days.header',
            ), // t('invoice.termsOfPayments.table.columns.days.header'),
            sortable: true,
            width: '200px',
          },
          {
            align: 'right',
            dataType: 'percent',
            field: 'Percent',
            header: getTranslationsForConfig(
              'invoice.termsOfPayments.table.columns.percent.header',
            ), // t('invoice.termsOfPayments.table.columns.percent.header'),
            sortable: true,
            width: '200px',
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'invoice.termsOfPayments.table.emptyMessageDetails',
        ), // t('invoice.termsOfPayments.table.emptyMessageDetails'),
        emptyMessageTitle: getTranslationsForConfig(
          'invoice.termsOfPayments.table.emptyMessageTitle',
        ), // t('invoice.termsOfPayments.table.emptyMessageTitle'),
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 8 attachments
    attachment: {
      enabled: true,
      title: getTranslationsForConfig('invoice.attachments.title'), // t('invoice.attachments.title'),
      additionalDocuments: {
        enabled: true,
        title: getTranslationsForConfig('invoice.attachments.table.title'), // t('invoice.attachments.table.title'),
        columns: [
          {
            // Dateiname
            dataType: 'string',
            field: 'Name',
            header: getTranslationsForConfig(
              'invoice.attachments.table.columns.name.header',
            ), // t('invoice.attachments.table.columns.name.header'),
            width: '400px',
          },
          {
            // Kategorie
            dataType: 'attachmentCategory',
            field: 'Category',
            header: getTranslationsForConfig(
              'invoice.attachments.table.columns.category.header',
            ), // t('invoice.attachments.table.columns.category.header'),
          },
          {
            // Status
            dataType: 'attachmentStatus',
            field: 'Status',
            header: getTranslationsForConfig(
              'invoice.attachments.table.columns.status.header',
            ), // t('invoice.attachments.table.columns.status.header'),
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'invoice.attachments.table.emptyMessageDetails',
        ), // t('invoice.attachments.table.emptyMessageDetails'),
        emptyMessageTitle: getTranslationsForConfig(
          'invoice.attachments.table.emptyMessageTitle',
        ), // t('invoice.attachments.table.emptyMessageTitle'),
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },

    // allowance charges dialogs
    // 9 rejectAllowanceCharges
    rejectAllowanceCharges: {
      enabled: true,
    },
    // 10 acceptAllowanceCharges
    acceptAllowanceCharges: {
      enabled: true,
    },
    // 11 addAllowanceCharge
    addAllowanceCharge: {
      enabled: true,
      // Typ
      confirmationAlcType: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.add.dialog.confirmationAlcType.label',
        ), // t('invoice.allowanceCharges.table.add.dialog.confirmationAlcType.label'),
        options: [
          {
            name: getTranslationsForConfig(
              'invoice.allowanceCharges.table.add.dialog.confirmationAlcType.options.surcharge',
            ), // t('invoice.allowanceCharges.table.add.dialog.confirmationAlcType.options.surcharge'),
            code: 'Surcharge',
          },
          {
            name: getTranslationsForConfig(
              'invoice.allowanceCharges.table.add.dialog.confirmationAlcType.options.discount',
            ), // t('invoice.allowanceCharges.table.add.dialog.confirmationAlcType.options.discount'),
            code: 'Discount',
          },
        ],
        placeholder: getTranslationsForConfig(
          'invoice.allowanceCharges.table.add.dialog.confirmationAlcType.placeholder',
        ), // t('invoice.allowanceCharges.table.add.dialog.confirmationAlcType.placeholder'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Beschreibung
      confirmationDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.add.dialog.confirmationDescription.label',
        ), // t('invoice.allowanceCharges.table.add.dialog.confirmationDescription.label'),
        options: [
          {
            name: getTranslationsForConfig(
              'invoice.allowanceCharges.table.add.dialog.confirmationDescription.options.freight',
            ), // t('invoice.allowanceCharges.table.add.dialog.confirmationDescription.options.freight'),
            code: 'Freight',
          },
          {
            name: getTranslationsForConfig(
              'invoice.allowanceCharges.table.add.dialog.confirmationDescription.options.packaging',
            ), // t('invoice.allowanceCharges.table.add.dialog.confirmationDescription.options.packaging'),
            code: 'Packaging',
          },
          {
            name: getTranslationsForConfig(
              'invoice.allowanceCharges.table.add.dialog.confirmationDescription.options.customs',
            ), // t('invoice.allowanceCharges.table.add.dialog.confirmationDescription.options.customs'),
            code: 'Customs',
          },
        ],
        placeholder: getTranslationsForConfig(
          'invoice.allowanceCharges.table.add.dialog.confirmationDescription.placeholder',
        ), // t('invoice.allowanceCharges.table.add.dialog.confirmationDescription.placeholder'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Prozentsatz
      confirmationPercentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.add.dialog.confirmationPercentage.label',
        ), // t('invoice.allowanceCharges.table.add.dialog.confirmationPercentage.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Betrag
      confirmationAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.add.dialog.confirmationAmount.label',
        ), // t('invoice.allowanceCharges.table.add.dialog.confirmationAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 12 infoAllowanceCharge
    infoAllowanceCharge: {
      enabled: true,
      // Typ
      alcType: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.info.dialog.alcType.label',
        ), // t('invoice.allowanceCharges.table.info.dialog.alcType.label'),
      },
      // Beschreibung
      descriptionText: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.info.dialog.descriptionText.label',
        ), // t('invoice.allowanceCharges.table.info.dialog.descriptionText.label'),
      },
      // Prozentsatz
      percentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.info.dialog.percentage.label',
        ), // t('invoice.allowanceCharges.table.info.dialog.percentage.label'),
      },
      // Neuer Prozentsatz
      confirmationPercentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.info.dialog.confirmationPercentage.label',
        ), // t('invoice.allowanceCharges.table.info.dialog.confirmationPercentage.label'),
      },
      // Betrag
      amount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.info.dialog.amount.label',
        ), // t('invoice.allowanceCharges.table.info.dialog.amount.label'),
      },
      // Neuer Betrag
      confirmationAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.info.dialog.confirmationAmount.label',
        ), // t('invoice.allowanceCharges.table.info.dialog.confirmationAmount.label'),
      },
    },
    // 13 editAllowanceCharge
    editAllowanceCharge: {
      enabled: true,
      // Typ
      alcType: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.edit.dialog.alcType.label',
        ), // t('invoice.allowanceCharges.table.edit.dialog.alcType.label'),
      },
      // Beschreibung
      descriptionText: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.edit.dialog.descriptionText.label',
        ), // t('invoice.allowanceCharges.table.edit.dialog.descriptionText.label'),
      },
      // Prozentsatz
      percentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.edit.dialog.percentage.label',
        ), // t('invoice.allowanceCharges.table.edit.dialog.percentage.label'),
      },
      // Neuer Prozentsatz
      confirmationPercentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.edit.dialog.confirmationPercentage.label',
        ), // t('invoice.allowanceCharges.table.edit.dialog.confirmationPercentage.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Betrag
      amount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.edit.dialog.amount.label',
        ), // t('invoice.allowanceCharges.table.edit.dialog.amount.label'),
      },
      // Neuer Betrag
      confirmationAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.allowanceCharges.table.edit.dialog.confirmationAmount.label',
        ), // t('invoice.allowanceCharges.table.edit.dialog.confirmationAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },

    // invoice item dialogs
    // 14 acceptInvoiceItems
    acceptInvoiceItems: {
      enabled: true,
    },
    // 15 infoInvoiceItem
    infoInvoiceItem: {
      enabled: true,
      itemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.itemId.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.itemId.label'),
      },
      confirmationItemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationItemId.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationItemId.label'),
      },
      countryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.countryOfOrigin.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.countryOfOrigin.label'),
      },
      confirmationCountryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationCountryOfOrigin.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationCountryOfOrigin.label'),
      },

      gtin: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.gtin.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.gtin.label'),
      },

      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.buyerProductId.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.buyerProductId.label'),
      },
      confirmationSellerProductId: {
        enabled: false,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationSellerProductId.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationSellerProductId.label'),
      },

      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.buyerProductDescription.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.buyerProductDescription.label'),
      },
      confirmationSellerProductDescription: {
        enabled: false,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationSellerProductDescription.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationSellerProductDescription.label'),
      },
      quantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.orderQuantity.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.orderQuantity.label'),
      },
      confirmationQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationQuantity.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationQuantity.label'),
      },
      unit: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.orderUnit.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.orderUnit.label'),
      },
      confirmationUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationUnit.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationUnit.label'),
      },
      priceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.orderPriceBaseQuantity.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.orderPriceBaseQuantity.label'),
      },
      confirmationPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationPriceBaseQuantity.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationPriceBaseQuantity.label'),
      },
      priceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.orderPriceUnitOfMeasure.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.orderPriceUnitOfMeasure.label'),
      },
      confirmationPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationPriceUnitOfMeasure.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationPriceUnitOfMeasure.label'),
      },
      price: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.orderPrice.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.orderPrice.label'),
      },
      confirmationPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationPrice.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationPrice.label'),
      },
      priceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.orderPriceSum.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.orderPriceSum.label'),
      },
      confirmationPriceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationPriceSum.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationPriceSum.label'),
      },
      allowanceChargeSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.allowanceChargeSum.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.allowanceChargeSum.label'),
      },
      confirmationAllowanceChargeSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationAllowanceChargeSum.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationAllowanceChargeSum.label'),
      },
      lineItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.lineItemAmount.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.lineItemAmount.label'),
      },
      confirmationLineItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationLineItemAmount.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationLineItemAmount.label'),
      },
      deliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.orderDeliveryDate.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.orderDeliveryDate.label'),
      },
      confirmationDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationDeliveryDate.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationDeliveryDate.label'),
      },

      confirmationReasonCode: {
        enabled: false,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationReasonCode.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationReasonCode.label'),
        options: [
          {
            name: getTranslationsForConfig(
              'invoice.invoiceItems.table.info.dialog.form.confirmationReasonCode.options.notAvailable',
            ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationReasonCode.options.notAvailable'),
            code: 'notAvailable',
          },
        ],
      },
      confirmationReasonDescription: {
        enabled: false,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.confirmationReasonDescription.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.confirmationReasonDescription.label'),
      },

      notes: {
        enabled: false,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.info.dialog.form.notes.label',
        ), // t('invoice.invoiceItems.table.info.dialog.form.notes.label'),
      },

      allowanceCharges: {
        enabled: false,
        table: {
          enabled: true,
          columns: [
            {
              dataType: 'string',
              enabled: true,
              field: 'ConfirmationDescription',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.descriptionText.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.descriptionText.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.descriptionText.header',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.descriptionText.header'),
              sortable: true,
            },
            {
              dataType: 'alcType',
              enabled: true,
              field: 'AlcType',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.alcType.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.alcType.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.alcType.header',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.alcType.header'),
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'percent',
              enabled: true,
              field: 'Percentage',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.percentage.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.percentage.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.percentage.header',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.percentage.header'),
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'price',
              enabled: true,
              field: 'Amount',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.amount.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.amount.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.amount.header',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.amount.header'),
              sortable: true,
            },
            {
              dataType: 'status',
              enabled: true,
              field: 'Status',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.status.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.status.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.status.header',
              ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.columns.status.header'),
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.emptyMessageDetails',
          ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.emptyMessageDetails'),
          emptyMessageTitle: getTranslationsForConfig(
            'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.emptyMessageTitle',
          ), // t('invoice.invoiceItems.table.info.dialog.allowanceCharges.table.emptyMessageTitle'),
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Payload.OrderDate',
          sortOrder: 1,
        },
      },
    },
    // 16 editInvoiceItem
    editInvoiceItem: {
      enabled: true,
      itemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.itemId.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.itemId.label'),
      },
      confirmationItemId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationItemId.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationItemId.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      countryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.countryOfOrigin.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.countryOfOrigin.label'),
      },
      confirmationCountryOfOrigin: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationCountryOfOrigin.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationCountryOfOrigin.label'),
        readonly: false,
        validation: {
          isRequired: false,
          regex: '^[A-Za-z]{1,9}$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceItems.table.edit.dialog.form.confirmationCountryOfOrigin.regexErrorMessage',
          ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationCountryOfOrigin.regexErrorMessage'),
        },
      },
      gtin: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.gtin.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.gtin.label'),
      },
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.buyerProductId.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.buyerProductId.label'),
      },
      confirmationSellerProductId: {
        enabled: false,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationSellerProductId.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationSellerProductId.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },

      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.buyerProductDescription.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.buyerProductDescription.label'),
      },
      confirmationSellerProductDescription: {
        enabled: false,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationSellerProductDescription.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationSellerProductDescription.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      quantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.orderQuantity.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.orderQuantity.label'),
      },
      confirmationQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationQuantity.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationQuantity.label'),
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceItems.table.edit.dialog.form.confirmationQuantity.regexErrorMessage',
          ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationQuantity.regexErrorMessage'),
        },
      },
      unit: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.orderUnit.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.orderUnit.label'),
      },
      confirmationUnit: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationUnit.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationUnit.label'),
        readonly: true,
        validation: {
          isRequired: true,
        },
      },
      priceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.orderPriceBaseQuantity.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.orderPriceBaseQuantity.label'),
      },
      confirmationPriceBaseQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationPriceBaseQuantity.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationPriceBaseQuantity.label'),
        readonly: true,
        validation: {
          isRequired: true,
        },
      },
      priceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.orderPriceUnitOfMeasure.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.orderPriceUnitOfMeasure.label'),
      },
      confirmationPriceUnitOfMeasure: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationPriceUnitOfMeasure.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationPriceUnitOfMeasure.label'),
        readonly: true,
        validation: {
          isRequired: true,
          regex: '^.{0,3}$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceItems.table.edit.dialog.form.confirmationPriceUnitOfMeasure.regexErrorMessage',
          ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationPriceUnitOfMeasure.regexErrorMessage'),
        },
      },
      price: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.orderPrice.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.orderPrice.label'),
      },
      confirmationPrice: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationPrice.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationPrice.label'),
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceItems.table.edit.dialog.form.confirmationPrice.regexErrorMessage',
          ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationPrice.regexErrorMessage'),
        },
      },
      priceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.orderPriceSum.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.orderPriceSum.label'),
      },
      confirmationPriceSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationPriceSum.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationPriceSum.label'),
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^(?!-)(\\d+(\\.\\d+)?|\\.\\d+)$',
          regexErrorMessage: getTranslationsForConfig(
            'invoice.invoiceItems.table.edit.dialog.form.confirmationPriceSum.regexErrorMessage',
          ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationPriceSum.regexErrorMessage'),
        },
      },
      allowanceChargeSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.allowanceChargeSum.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.allowanceChargeSum.label'),
      },
      confirmationAllowanceChargeSum: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationAllowanceChargeSum.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationAllowanceChargeSum.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      lineItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.lineItemAmount.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.lineItemAmount.label'),
      },
      confirmationLineItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationLineItemAmount.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationLineItemAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      deliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.orderDeliveryDate.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.orderDeliveryDate.label'),
      },
      confirmationDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.form.confirmationDeliveryDate.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.form.confirmationDeliveryDate.label'),
        readonly: true,
        validation: {
          isRequired: false,
        },
      },

      allowanceCharges: {
        enabled: false,
        table: {
          enabled: true,
          columns: [
            {
              dataType: 'string',
              enabled: true,
              field: 'ConfirmationDescription',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.descriptionText.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.descriptionText.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.descriptionText.header',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.descriptionText.header'),
              sortable: true,
            },
            {
              dataType: 'alcType',
              enabled: true,
              field: 'ConfirmationAlcType',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.alcType.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.alcType.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.alcType.header',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.alcType.header'),
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'percent',
              enabled: true,
              field: 'ConfirmationPercentage',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.percentage.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.percentage.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.percentage.header',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.percentage.header'),
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'price',
              enabled: true,
              field: 'ConfirmationAmount',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.amount.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.amount.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.amount.header',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.amount.header'),
              sortable: true,
            },
            {
              dataType: 'status',
              enabled: true,
              field: 'Status',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.status.filterPlaceholder',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.status.filterPlaceholder'),
              header: getTranslationsForConfig(
                'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.status.header',
              ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.columns.status.header'),
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.emptyMessageDetails',
          ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.emptyMessageDetails'),
          emptyMessageTitle: getTranslationsForConfig(
            'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.emptyMessageTitle',
          ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.emptyMessageTitle'),
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Payload.OrderDate',
          sortOrder: 1,
        },
      },
    },
    // 17 rejectInvoiceItemAllowanceCharges
    rejectInvoiceItemAllowanceCharges: {
      enabled: true,
    },
    // 18 acceptInvoiceItemAllowanceCharges
    acceptInvoiceItemAllowanceCharges: {
      enabled: true,
    },
    // 19 addInvoiceItemAllowanceCharge
    addInvoiceItemAllowanceCharge: {
      enabled: true,
      // Typ
      confirmationAlcType: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.label'),
        options: [
          {
            name: getTranslationsForConfig(
              'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.options.surcharge',
            ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.options.surcharge'),
            code: 'Surcharge',
          },
          {
            name: getTranslationsForConfig(
              'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.options.discount',
            ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.options.discount'),
            code: 'Discount',
          },
        ],
        placeholder: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.placeholder',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAlcType.placeholder'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Beschreibung
      confirmationDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.label'),
        options: [
          {
            name: getTranslationsForConfig(
              'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.options.freight',
            ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.options.freight'),
            code: 'Freight',
          },
          {
            name: getTranslationsForConfig(
              'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.options.packaging',
            ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.options.packaging'),
            code: 'Packaging',
          },
          {
            name: getTranslationsForConfig(
              'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.options.customs',
            ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.options.customs'),
            code: 'Customs',
          },
        ],
        placeholder: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.placeholder',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationDescription.placeholder'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Prozentsatz
      confirmationPercentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationPercentage.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationPercentage.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Betrag
      confirmationAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAmount.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.add.dialog.confirmationAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 20 infoInvoiceItemAllowanceCharge
    infoInvoiceItemAllowanceCharge: {
      enabled: true,
      // Typ
      alcType: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.alcType.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.alcType.label'),
      },
      // Beschreibung
      descriptionText: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.descriptionText.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.descriptionText.label'),
      },
      // Prozentsatz
      percentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.percentage.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.percentage.label'),
      },
      // Neuer Prozentsatz
      confirmationPercentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.confirmationPercentage.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.confirmationPercentage.label'),
      },
      // Betrag
      amount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.amount.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.amount.label'),
      },
      // Neuer Betrag
      confirmationAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.confirmationAmount.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.info.dialog.confirmationAmount.label'),
      },
    },
    // 21 editInvoiceItemAllowanceCharge
    editInvoiceItemAllowanceCharge: {
      enabled: true,
      // Typ
      alcType: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.alcType.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.alcType.label'),
      },
      // Beschreibung
      descriptionText: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.descriptionText.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.descriptionText.label'),
      },
      // Prozentsatz
      percentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.percentage.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.percentage.label'),
      },
      // Neuer Prozentsatz
      confirmationPercentage: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.confirmationPercentage.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.confirmationPercentage.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
      // Betrag
      amount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.amount.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.amount.label'),
      },
      // Neuer Betrag
      confirmationAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.confirmationAmount.label',
        ), // t('invoice.invoiceItems.table.edit.dialog.allowanceCharges.table.edit.dialog.confirmationAmount.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },

    // terms of payment dialogs
    // 22 deleteTermOfPayment
    deleteTermsOfPayment: {
      enabled: false,
    },
    // 23 addTermOfPayment
    addTermsOfPayment: {
      enabled: false,
      days: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.termsOfPayments.table.add.dialog.days.label',
        ), // t('invoice.termsOfPayments.table.add.dialog.days.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      percent: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.termsOfPayments.table.add.dialog.percent.label',
        ), // t('invoice.termsOfPayments.table.add.dialog.percent.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },
    // 24 editTermOfPayment
    editTermsOfPayment: {
      enabled: false,
      days: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.termsOfPayments.table.edit.dialog.days.label',
        ), // t('invoice.termsOfPayments.table.edit.dialog.days.label'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      percent: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.termsOfPayments.table.edit.dialog.percent.label',
        ), // t('invoice.termsOfPayments.table.edit.dialog.percent.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },

    // invoice dialogs
    // 25 rejectInvoice
    rejectInvoice: {
      enabled: true,
      // Ablehnungsgrund
      confirmationReasonCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.reject.dialog.confirmationReasonCode.label',
        ), // t('invoice.title.reject.dialog.confirmationReasonCode.label'),
        options: [
          {
            name: getTranslationsForConfig(
              'invoice.title.reject.dialog.confirmationReasonCode.options.noDelivery',
            ), // t('invoice.title.reject.dialog.confirmationReasonCode.options.noDelivery'),
            code: 'noDelivery',
          },
          {
            name: getTranslationsForConfig(
              'invoice.title.reject.dialog.confirmationReasonCode.options.other',
            ), // t('invoice.title.reject.dialog.confirmationReasonCode.options.other'),
            code: 'other',
          },
        ],
        placeholder: getTranslationsForConfig(
          'invoice.title.reject.dialog.confirmationReasonCode.placeholder',
        ), // t('invoice.title.reject.dialog.confirmationReasonCode.placeholder'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Erklärung
      confirmationReasonDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.reject.dialog.confirmationReasonDescription.label',
        ), // t('invoice.title.reject.dialog.confirmationReasonDescription.label'),
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },
    // 26 acceptInvoice
    acceptInvoice: {
      enabled: true,
      invoiceNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.invoiceNumber.label',
        ), // t('invoice.title.send.dialog.invoiceNumber.label'),
      },
      invoiceDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.invoiceDate.label',
        ), // t('invoice.title.send.dialog.invoiceDate.label'),
      },
      confirmationTotalNetItemAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.confirmationTotalNetItemAmount.label',
        ), // t('invoice.title.send.dialog.confirmationTotalNetItemAmount.label'),
      },
      confirmationSurcharge: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.confirmationSurcharge.label',
        ), // t('invoice.title.send.dialog.confirmationSurcharge.label'),
      },
      confirmationNetAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.confirmationNetAmount.label',
        ), // t('invoice.title.send.dialog.confirmationNetAmount.label'),
      },
      confirmationTaxRate: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.confirmationTaxRate.label',
        ), // t('invoice.title.send.dialog.confirmationTaxRate.label'),
      },
      confirmationTaxValue: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.confirmationTaxValue.label',
        ), // t('invoice.title.send.dialog.confirmationTaxValue.label'),
      },
      confirmationInvoiceAmount: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.title.send.dialog.confirmationInvoiceAmount.label',
        ), // t('invoice.title.send.dialog.confirmationInvoiceAmount.label'),
      },

      table: {
        enabled: true,
        columns: [
          {
            dataType: 'string',
            field: 'OrderPosition',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.orderPosition.header',
            ), // t('invoice.title.send.dialog.table.columns.orderPosition.header'),
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductId',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.confirmationProductId.header',
            ), // t('invoice.title.send.dialog.table.columns.confirmationProductId.header'),
          },
          {
            dataType: 'string',
            field: 'ConfirmationSellerProductDescription',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.confirmationDescription.header',
            ), // t('invoice.title.send.dialog.table.columns.confirmationDescription.header'),
          },
          {
            align: 'right',
            dataType: 'price',
            field: 'ConfirmationPrice',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.confirmationPrice.header',
            ), // t('invoice.title.send.dialog.table.columns.confirmationPrice.header'),
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationQuantity',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.confirmationQuantity.header',
            ), // t('invoice.title.send.dialog.table.columns.confirmationQuantity.header'),
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationLineItemAmount',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.confirmationLineItemAmount.header',
            ), // t('invoice.title.send.dialog.table.columns.confirmationLineItemAmount.header'),
          },
          {
            align: 'center',
            dataType: 'boolean',
            field: 'HasAllowanceChargeSum',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.hasAllowanceChargeSum.header',
            ), // t('invoice.title.send.dialog.table.columns.hasAllowanceChargeSum.header'),
          },
          {
            dataType: 'status',
            field: 'ConfirmationCode',
            header: getTranslationsForConfig(
              'invoice.title.send.dialog.table.columns.confirmationCode.header',
            ), // t('invoice.title.send.dialog.table.columns.confirmationCode.header'),
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'invoice.title.send.dialog.table.emptyMessageDetails',
        ), // t('invoice.title.send.dialog.table.emptyMessageDetails'),
        emptyMessageTitle: getTranslationsForConfig(
          'invoice.title.send.dialog.table.emptyMessageTitle',
        ), // t('invoice.title.send.dialog.table.emptyMessageTitle'),
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },

    // Attachment dialogs
    // 27 uploadAttachment
    uploadAttachment: {
      enabled: true,
      // Datei
      attachment: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.attachments.table.upload.dialog.form.attachment.label',
        ), // t('invoice.attachments.table.upload.dialog.form.attachment.label'),
        readonly: false,
        validation: {
          isRequired: true,
          maxFileSize: 5000000,
          accept: '.doc, .docx, .pdf, .ppt, .pptx, .xls, .xlsx',
        },
      },
      // Kategorie
      category: {
        enabled: true,
        label: getTranslationsForConfig(
          'invoice.attachments.table.upload.dialog.form.category.label',
        ), // t('invoice.attachments.table.upload.dialog.form.category.label'),
        options: [
          {
            name: getTranslationsForConfig(
              'invoice.attachments.table.upload.dialog.form.category.options.aiInvoiceDocument.name',
            ), // t('invoice.attachments.table.upload.dialog.form.category.options.aiInvoiceDocument.name'),
            code: 'aiInvoiceDocument',
          },
          {
            name: getTranslationsForConfig(
              'invoice.attachments.table.upload.dialog.form.category.options.invoiceDocument.name',
            ), // t('invoice.attachments.table.upload.dialog.form.category.options.invoiceDocument.name'),
            code: 'invoiceDocument',
          },
        ],
        placeholder: getTranslationsForConfig(
          'invoice.attachments.table.upload.dialog.form.category.placeholder',
        ), // t('invoice.attachments.table.upload.dialog.form.category.placeholder'),
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
  }
}
